import { createSelector } from "reselect";

// Selectors
import { createCsvExportForIdDownloadQuerySelector } from "../../../query_selectors/csv_exports";

/**
 * create a selector to get the context for a csv_export download
 * @param {Object} props
 * @param {string} props.csvExportId
 * @returns {function} selector
 */
export function createCsvExportForIdDownloadContextSelector({ csvExportId }) {
  return createSelector(
    createCsvExportForIdDownloadQuerySelector({
      csvExportId
    }),
    query => {
      return query;
    }
  );
}
